import {
    BULK_RMA_ACTION,
    BULK_REQUEST_STATUS,
} from '../../../../../services/api/bulk-rma-action-types';

export const REQUEST_STATUS_LABELS: Record<string, string> = {
    [BULK_REQUEST_STATUS.PROCESSING]: 'Processing',
    [BULK_REQUEST_STATUS.COMPLETED]: 'Completed',
    [BULK_REQUEST_STATUS.CANCELLED]: 'Cancelled',
};

export const ACTION_TYPE_LABELS: Record<string, string> = {
    [BULK_RMA_ACTION.MARK_DONE]: 'Mark as Done',
};

export const JOB_STATUS_LABELS: Record<string, string> = {
    queued: 'Queued',
    running: 'Running',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Cancelled',
};

export const RETURN_STATUS_LABELS: Record<string, string> = {
    pending: 'Pending',
    allocated: 'Allocated',
    processing: 'Processing',
    succeeded: 'Succeeded',
    blocked: 'Blocked',
    error: 'Error',
    cancelled: 'Cancelled',
};
